<template>
  <a-card :bordered="false">
    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('上门服务分类.分类名称')">
              <a-input v-model="queryParam.categoryName" @pressEnter="handleQuery" :maxLength="16"
                       :placeholder="$t('通用.输入.请输入')+$t('上门服务分类.分类名称')" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('上门服务分类.是否首页展示')">
              <a-select :placeholder="$t('通用.输入.请选择')+$t('上门服务分类.是否首页展示')"
                        style="width: 100%" v-model="queryParam.isHomeVisible" allowClear>
                <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type+''"
                                 :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
    </div>
    <!-- 操作 -->
    <div class="table-operations">
      <a-button type="primary" @click="$refs.createForm.handleAdd(0)" v-hasPermi="['homeservice:category:add']">
        <a-icon type="plus" />{{$t('上门服务分类.新增一级分类')}}
      </a-button>
      <table-setting
        :style="{float: 'right'}"
        :table-size.sync="tableSize"
        v-model="columns"
        :refresh-loading="loading"
        @refresh="getList" />
    </div>
    <!-- 增加修改 -->
    <create-form
      ref="createForm"
      @ok="getList"
    />
    <!-- 数据展示 -->
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      @change="handleSortChange"
      :expandedRowKeys="expandedKeys"
      @expand="onExpandCurrent"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="false"
      :bordered="tableBordered"
    >
      <span slot="expandedRowRender" slot-scope="text">
        <category-sub-list ref="subList" :id="text.id" />
      </span>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <template slot="icon" slot-scope="text, record">
        <div>
          <img v-if="record.icon" :src="record.icon" style="width:60px;height:60px;"
               @click="handleRecordPreview(record.icon)" alt="none"/>
        </div>
      </template>
      <span slot="categoryLevel" slot-scope="text, record">
        <a-tag :color="record.categoryLevel === 1 ? 'blue' : 'green'">
          {{ record.categoryLevel === 1 ? $t('上门服务分类.一级分类') : $t('上门服务分类.二级分类') }}
        </a-tag>
      </span>
      <span slot="isHomeVisible" slot-scope="text, record">
        <a-switch @change="(checked) => onHomeVisibleChange(checked,record)"
                  :checked-children="$t('通用.文本.是')" :un-checked-children="$t('通用.文本.否')"
                  :checked="record.isHomeVisible"/>
      </span>
      <span slot="operation" slot-scope="text, record">
        <a @click="$refs.createForm.handleAdd(record.id)" v-hasPermi="['homeservice:category:add']"
           v-if="record.categoryLevel === 1">
          <a-icon type="plus" />{{$t('上门服务分类.添加子分类')}}
        </a>
        <a-divider type="vertical" v-if="record.categoryLevel === 1" v-hasPermi="['homeservice:category:add']" />
        <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['homeservice:category:edit']">
           <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a>
        <a-divider type="vertical" v-hasPermi="['homeservice:category:remove']" />
        <a @click="handleDelete(record)" v-hasPermi="['homeservice:category:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a>
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-card>
</template>

<script>
import { pageCategory, delCategory, updateVisible } from '@/api/homeservice/category';
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import CreateForm from './modules/CreateForm'
import CategorySubList from './subList'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'HomeServiceCategory',
  components: {
    CustomDictTag,
    CategorySubList,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      filteredInfo: {},
      sortedInfo : {},
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      expandedKeys: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        categoryName: null,
        categoryLevel: 1,
        isHomeVisible: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('上门服务分类.分类名称'),
          dataIndex: 'categoryName',
          width: '15%',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('上门服务分类.分类图标'),
          dataIndex: 'icon',
          scopedSlots: { customRender: 'icon' },
          align: 'center'
        },
        {
          title: this.$t('上门服务分类.分类级别'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'categoryLevel',
          scopedSlots: { customRender: 'categoryLevel' },
          align: 'center'
        },
        {
          title: this.$t('上门服务分类.是否首页展示'),
          dataIndex: 'isHomeVisible',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'isHomeVisible' },
          align: 'center'
        },
        {
          title: this.$t('通用.文本.排序'),
          dataIndex: 'sort',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title:  this.$t('通用.文本.创建时间'),
          dataIndex: 'createTime',
          sorter: 1,
          ellipsis: true,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询分类列表 */
    getList () {
      this.loading = true
      pageCategory(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onExpandCurrent(expandedKeys, row) {
      if (expandedKeys) {
        this.expandedKeys = [row.id]
      } else {
        this.expandedKeys = []
      }
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        categoryName: undefined,
        categoryLevel: 1,
        isHomeVisible: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    onHomeVisibleChange(checked, record) {
      let data = {id: record.id, isHomeVisible: checked}
      updateVisible(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.修改成功'),
            3
          );
          this.$emit('ok')
          record.isHomeVisible = checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },

    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      const names = row.name
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCategory(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('通用.文本.删除成功'),
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    }
  }
}
</script>
<style lang="less">
.imgbox {
  overflow: hidden;
  background-color: #f7f7f7;
  position: relative;
  cursor: pointer;

  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.videomask {
  position: absolute;
  z-index: 10;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  line-height: 100px;
  background: rgba(0, 0, 0, .3);
  text-align: center;

  .icon {
    display: inline-block;
    font-size: 26px !important;
    color: #fff !important;
  }
}
</style>
